// removed by extract-text-webpack-plugin
module.exports = {"swiperPagination":"swiperPagination__14h4Y","dotWrap":"dotWrap__1L2LU","dotStyle":"dotStyle__CzH04","dotActiveStyle":"dotActiveStyle__3m3cJ","bannerTitleWrap":"bannerTitleWrap__2aVPU","bannerTitle":"bannerTitle__3ptiU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Swipe/index.css
// module id = 1576
// module chunks = 0